import { render, staticRenderFns } from "./propositionalTendencyAdd.vue?vue&type=template&id=2ff1360a&scoped=true&"
import script from "./propositionalTendencyAdd.vue?vue&type=script&lang=js&"
export * from "./propositionalTendencyAdd.vue?vue&type=script&lang=js&"
import style0 from "./propositionalTendencyAdd.vue?vue&type=style&index=0&id=2ff1360a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ff1360a",
  null
  
)

export default component.exports